// src/reducers/ai_reducers.js
import {
  FETCH_AI_CARDS_LOADING, FETCH_AI_CARDS_SUCCESS, FETCH_AI_CARDS_FAIL,
  SEND_AI_MESSAGE_LOADING, SEND_AI_MESSAGE_SUCCESS, SEND_AI_MESSAGE_FAIL,
  FETCH_AI_SESSIONS_LOADING, FETCH_AI_SESSIONS_SUCCESS, FETCH_AI_SESSIONS_FAIL,
  FETCH_AI_SESSION_HISTORY_LOADING, FETCH_AI_SESSION_HISTORY_SUCCESS, FETCH_AI_SESSION_HISTORY_FAIL,
  ADD_USER_MESSAGE, AI_RECEIVE_MESSAGE, CLEAR_AI_HISTORY,  CREATE_AI_SESSION_REQUEST,
  CREATE_AI_SESSION_SUCCESS, CREATE_AI_SESSION_FAILURE, FETCH_AI_ANALYTICS_HISTORY_LOADING,
  FETCH_AI_ANALYTICS_HISTORY_SUCCESS, FETCH_AI_ANALYTICS_HISTORY_FAIL
} from "../actions/types";

const INITIAL_STATE = {
  cards: [],
  cardsLoading: false,
  cardsError: null,

  messages: [],  // array of { from: 'user'|'ai', text, ... }
  sendingMessage: false,
  sendError: null,

  sessions: [],
  sessionsLoading: false,
  sessionsError: null,

  sessionHistory: [],
  historyLoading: false,
  historyError: null,

  creatingSession: false,
  createSessionError: null,

  analyticsHistoryLoading: false,
  analyticsHistory: [],
  analyticsHistoryError: null,
  analyticsTotalMessages: 0,
  analyticsLoadedTurns: 0 
};

export default function aiReducer(state = INITIAL_STATE, action) {
  switch (action.type) {

    case FETCH_AI_ANALYTICS_HISTORY_LOADING:
      return {
        ...state,
        analyticsHistoryLoading: true,
        analyticsHistoryError: null
      };

    case FETCH_AI_ANALYTICS_HISTORY_SUCCESS:
      return {
        ...state,
        analyticsHistoryLoading: false,
        analyticsHistory: action.meta?.offset > 0
          ? [...action.payload, ...state.analyticsHistory]
          : action.payload,
        analyticsTotalMessages: Number.isFinite(action.meta?.total)
          ? action.meta.total
          : state.analyticsTotalMessages,
          // offset is in **turns**, and we just fetched `pageTurns` more
          analyticsLoadedTurns:
            (Number.isFinite(action.meta?.offset) && Number.isFinite(action.meta?.pageTurns))
              ? (action.meta.offset + action.meta.pageTurns)
              : state.analyticsLoadedTurns    
      };

    case FETCH_AI_ANALYTICS_HISTORY_FAIL:
      return {
        ...state,
        analyticsHistoryLoading: false,
        analyticsHistoryError: action.payload
      };


    case CREATE_AI_SESSION_REQUEST:
     return {
       ...state,
       creatingSession: true,
       createSessionError: null
     };

    case CREATE_AI_SESSION_SUCCESS:
      return {
        ...state,
        creatingSession: false
      };

    case CREATE_AI_SESSION_FAILURE:
      return {
        ...state,
        creatingSession: false,
        createSessionError: action.payload
      };

    case CLEAR_AI_HISTORY:
      return {
        ...state,
        sessionHistory: [],
        analyticsHistory: [],
        analyticsTotalMessages: 0,
        analyticsLoadedTurns: 0
      };

    case FETCH_AI_CARDS_LOADING:
      return { ...state, cardsLoading: true, cardsError: null };
    case FETCH_AI_CARDS_SUCCESS:
      return { ...state, cardsLoading: false, cards: action.payload };
    case FETCH_AI_CARDS_FAIL:
      return { ...state, cardsLoading: false, cardsError: action.payload };

    // handle the user’s bubble
    case ADD_USER_MESSAGE:
      return {
        ...state,
         analyticsHistory: [...state.analyticsHistory, action.payload]
        // sessionHistory: [
        //   ...state.sessionHistory,
        //   action.payload
        // ]
     // NOTE: we intentionally do NOT inject into analytics here.
    // The bot reply will appear after a future analytics fetch (outside this step).
      };


    // append incoming AI reply (drop any placeholder first)
case AI_RECEIVE_MESSAGE: {
  const p = action.payload || {};
  const turns = Array.isArray(p.messages) ? p.messages : [];
  const lastTurn = turns.length ? turns[turns.length - 1] : undefined;

  // Bot text priorities: new payload uses `response`
  const botText =
    (p.response && String(p.response)) ||
    (p.bot_message && String(p.bot_message)) ||
    (lastTurn?.bot_message && String(lastTurn.bot_message)) ||
    p.text || p.message || p.reply || "";

  const actionCards =
    Array.isArray(p.action_cards) ? p.action_cards
    : Array.isArray(lastTurn?.action_cards) ? lastTurn.action_cards
    : [];

  // Preserve barsys fully if provided; then merge legacy fallbacks
  let barsys = p.barsys ? { ...p.barsys } : (lastTurn?.barsys ? { ...lastTurn.barsys } : {});

  // If server returned top-level barsys_recipe, merge into barsys.recipes
  const topBarsysRecipes =
    Array.isArray(p.barsys_recipe) ? p.barsys_recipe
    : Array.isArray(lastTurn?.barsys_recipe) ? lastTurn.barsys_recipe
    : [];
  if (topBarsysRecipes.length) {
    barsys.recipes = [...(barsys.recipes || []), ...topBarsysRecipes];
  }

  // Normalize barsys_mixlist (top-level or on lastTurn) into barsys.mixlists (array)
  const asArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);
  const mixlistsCombined = [
    ...asArray(p.barsys_mixlist),
    ...asArray(lastTurn?.barsys_mixlist)
  ];
  if (mixlistsCombined.length) {
    barsys.mixlists = [...(barsys.mixlists || []), ...mixlistsCombined];
  }

  // AI recipes: keep whatever server sent; also alias top-level recipes for UI
  const aiGenerated =
    Array.isArray(p.ai_generated_recipe) ? p.ai_generated_recipe
    : Array.isArray(lastTurn?.ai_generated_recipe) ? lastTurn.ai_generated_recipe
    : null;

  const topLevelRecipes = Array.isArray(p.recipes) ? p.recipes : null;

  const createdAt = p.created_at || lastTurn?.created_at || undefined;

  const botBubble = {
    from: "bot",
    text: botText,
    created_at: createdAt,
    action_cards: actionCards,
    ai_generated_recipe: aiGenerated,
    recipes: topLevelRecipes,
    barsys: Object.keys(barsys).length ? barsys : undefined
  };

  return {
    ...state,
    sendingMessage: false,
    analyticsHistory: state.analyticsHistory
      .filter(m => !m.typing)
      .concat(botBubble)
  };
}


    case SEND_AI_MESSAGE_LOADING:
      return {
        ...state,
        sendingMessage: true,
        sendError: null,
        analyticsHistory: [
          ...state.analyticsHistory,
        { from: 'bot', text: '', typing: true }
      ]
      };

    case SEND_AI_MESSAGE_SUCCESS:
      return {
        ...state,
        sendingMessage: false,
        analyticsHistory: state.analyticsHistory.filter(m => !m.typing)
      };


      case SEND_AI_MESSAGE_FAIL:
        return {
          ...state,
          sendingMessage: false,
          sendError: action.payload.text,
          // drop the typing bubble, then show an error bubble from the bot
          analyticsHistory: state.analyticsHistory
            .filter(m => !m.typing)
            .concat(action.payload)
        };


    case FETCH_AI_SESSIONS_LOADING:
      return { ...state, sessionsLoading: true, sessionsError: null };

    case FETCH_AI_SESSIONS_SUCCESS:
      return {
        ...state,
        sessionsLoading: false,
        sessions: action.payload   // now an array of {id, title, createdAt}
      };

    case FETCH_AI_SESSIONS_FAIL:
      return {
        ...state,
        sessionsLoading: false,
        sessionsError: action.payload
      };


    case FETCH_AI_SESSION_HISTORY_LOADING:
      return { ...state, historyLoading: true, historyError: null };
    case FETCH_AI_SESSION_HISTORY_SUCCESS:
      return { ...state, historyLoading: false, sessionHistory: action.payload };
    case FETCH_AI_SESSION_HISTORY_FAIL:
      return { ...state, historyLoading: false, historyError: action.payload };

    default:
      return state;
  }
}
